// src/pages/ExpertisePage.js
import React from 'react';
import ExpertiseCard from '../components/ExpertiseCard';
import expertiseData from '../data/expertise.json';
import '../styles/ExpertisePage.css';

function ExpertisePage() {
  return (
    <div className="expertise-page">
      <h1>Expertise</h1>
      <div className="expertise-grid">
        {expertiseData.map((expertise, index) => (
          <ExpertiseCard
            key={index} // unique key for each expertise entry
            title={expertise.title}
            description={expertise.description}
            image={expertise.image}
            people={expertise.people} // passing people array to the card
          />
        ))}
      </div>
    </div>
  );
}

export default ExpertisePage;
